<template>
    <div v-if="total > 1" class="page-turn-control" :style="controlStyle">
        <button class="page-turn-button" type="button" :style="buttonStyle" @click="$emit('prev')">&lt;上一页</button>
        <span class="page-turn-count" :style="countStyle">{{ current }} / {{ total }}</span>
        <button class="page-turn-button" type="button" :style="buttonStyle" @click="$emit('next')">下一页&gt;</button>
    </div>
</template>

<script>
    const THEME_MAP = {
        article: {
            text: '#2E670B',
            border: '#96C59D',
            background: 'rgba(186, 236, 202, 0.75)',
            accent: '#106BC0',
        },
        meal: {
            text: '#0A7B23',
            border: '#59C06F',
            background: '#b2f5c2',
            accentBackground: '#8EDE9F',
        },
    }

    export default {
        name: 'PageTurnControl',
        props: {
            current: {
                type: Number,
                default: 1,
            },
            total: {
                type: Number,
                default: 0,
            },
            theme: {
                type: String,
                default: 'meal',
            },
        },
        computed: {
            themeConfig() {
                return THEME_MAP[this.theme] || THEME_MAP.meal
            },
            controlStyle() {
                return {
                    color: this.themeConfig.text,
                    borderColor: this.themeConfig.border,
                    background: this.themeConfig.background,
                }
            },
            buttonStyle() {
                return {
                    color: this.themeConfig.text,
                }
            },
            countStyle() {
                return {
                    color: this.themeConfig.accent || this.themeConfig.text,
                    background: this.themeConfig.accentBackground || 'transparent',
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .page-turn-control {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: vh(24);
        width: fit-content;
        max-width: 90%;
        margin: vh(10) auto 0;
        padding: vh(6) vh(18);
        border: vh(1) solid;
        border-radius: vh(18);
        font-size: vh(18);
        font-weight: bold;
        line-height: 1;
    }

    .page-turn-button {
        border: none;
        background: transparent;
        font: inherit;
        font-weight: bold;
        cursor: pointer;
        padding: vh(4) vh(8);
        white-space: nowrap;
    }

    .page-turn-count {
        min-width: vh(56);
        padding: vh(4) vh(10);
        border-radius: vh(12);
        text-align: center;
        white-space: nowrap;
    }
</style>
